import { action, observable, computed, makeObservable } from "mobx";
import { SeniorProposal, SeniorProposalModel } from "./seniorProposalModel";

export interface SafeSeniorProposalModel {
    seniors: SeniorProposalModel[];
    safeSeniorClientsDulicate: boolean;

    setNumberOfSeniors: (count: number) => void;
    validate: () => void;
    clearErrorMessages: () => void;
    reset: () => void;
}

interface SafeSeniorProposalArguments {
    seniors: SeniorProposalModel[];
}

export class SafeSeniorProposal implements SafeSeniorProposalModel {
    @observable seniors = [] as SeniorProposalModel[];

    constructor(args?: SafeSeniorProposalArguments) {
        makeObservable(this);

        this.seniors = args?.seniors ?? [new SeniorProposal()];
    }

    @action
    public setNumberOfSeniors(count: number) {
        const seniorsCount = this.seniors.length;
        const diff = count - seniorsCount;

        if (diff > 0) {
            for (let i = 0; i < diff; i++) {
                this.seniors.push(new SeniorProposal());
            }
        } else if (diff < 0) {
            for (let i = 0; i < Math.abs(diff); i++) {
                this.seniors.pop();
            }
        }
    }

    @computed
    public get safeSeniorClientsDulicate() {
        const pesels = this.seniors.filter(x => x.pesel.value !== "").map(x => x.pesel.value);

        return (new Set(pesels).size !== pesels.length);
    }

    @action
    public reset() {
        this.seniors = [];
    }

    @action
    public validate() {
        this.seniors.forEach(senior => {
            senior.validate();
        });
    }

    @action
    public clearErrorMessages() {
        this.seniors.forEach(senior => {
            senior.clearErrorMessages();
        });
    }
}
